import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=7678e124&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=7678e124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678e124",
  null
  
)

export default component.exports